import { useTranslation } from 'react-i18next'

// Adding a new code = add a case here. Direct t(...) call sites keep i18next's
// typed-key inference happy (a Record<string, key-literal> would widen to
// plain string and break the typed `t` overloads).
export function titleForCode(
  code: string,
  t: ReturnType<typeof useTranslation>['t'],
): string {
  switch (code) {
    case 'missing_pages':
      return t('preCheckInfo.missing_pages.title')
    case 'missing_person':
      return t('preCheckInfo.missing_person.title')
    default:
      return t('preCheckInfo.generic.title')
  }
}

export function bodyForCode(
  code: string,
  t: ReturnType<typeof useTranslation>['t'],
): string {
  switch (code) {
    case 'missing_pages':
      return t('preCheckInfo.missing_pages.body')
    case 'missing_person':
      return t('preCheckInfo.missing_person.body')
    default:
      return ''
  }
}

/**
 * Inline list of pre-check warning details. Used by both the wizard's panel
 * (below the action row) and the combine confirm dialog. Each code becomes a
 * titled section with explanatory body text; codes are deduped defensively in
 * case the backend ever returns the same code twice.
 */
export function PreCheckWarningList({ codes }: { codes: string[] }) {
  const { t } = useTranslation()
  const uniqueCodes = Array.from(new Set(codes))
  if (uniqueCodes.length === 0) return null
  return (
    <div className="space-y-4 text-sm">
      {uniqueCodes.map((code) => (
        <div key={code} className="space-y-1">
          <p className="font-medium">{titleForCode(code, t)}</p>
          <p className="text-text-secondary">{bodyForCode(code, t)}</p>
        </div>
      ))}
    </div>
  )
}
